import { Button, Container, Form, FormField, Link, Multiselect, SelectProps } from '@cloudscape-design/components';
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect } from 'react';
import { CustomAppLayout } from '../../../layout';
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import * as XLSX from "xlsx";
import Favorites from '../../../../../components/extras/Favorites';
import MPModal from '../../../../../components/MPModal';
import SelectCheck from '../../../../../components/selects/selectChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading, setParameters } from '../../../../commons/functions';
import { useGlobalState } from '../../../../context/GlobalStateContext';

type OptionDefinition = SelectProps.Option;

export const DownloadsChecksPage = () => {
    const { data, menu, parameters } = useGlobalState();



    const [selectedStatues, setSelectedStatues] = React.useState<OptionDefinition[]>([]);
    const [selectedChecks, setSelectedChecks] = React.useState<number[]>([]);

    const [listChecks, setListChecks] = React.useState<OptionDefinition[]>([]);


    const handleRefreshMovements = async () => {

        try {
            setLoading(true);
            const idStatusesRequests: number[] = selectedStatues
                .map(opt => opt.value ? Number(opt.value) : undefined) // convert string → number
                .filter((v): v is number => v !== undefined);
            const idChecks: number[] = selectedChecks
            const bodyObject: any = {
                orderBy: "dateSubmited",
                order: "desc",
                limit: 200,
                columns: "idCheck, isDeleteCheck, [check], idRequest, result, dateSubmited, dateAssigned, dateResult, statusRequest, instructor, cancelReason, expiresIn, isRepeat, dateExpires, displayName, status, obsPilot, category"
            };
            if (parameters.period !== "") {
                bodyObject.month = parameters.period.split("-")[1];
                bodyObject.year = parameters.period.split("-")[0];
            }
            if (idStatusesRequests !== undefined && idStatusesRequests.length > 0) {
                bodyObject.statusesRequest = idStatusesRequests;
            }
            if (idChecks !== undefined && idChecks.length > 0) {
                bodyObject.idChecks = idChecks;
            }
            const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'x-routing': '/private/checks/search.requests',
                    'JWT': getCookie("JWT"),
                    //  
                },
                body: JSON.stringify(bodyObject),
                //mode: 'no-cors'  // Bypasses CORS but limits the response
            });

            if (!response.ok) {
                throw new Error(`HTTP error: ${response.status}`);
            }
            const data = await response.json();
            if (data.code == 0) {
                if (data.checks.length === 0) {
                    addNotificationStatus(data, setData);
                } else {
                    const ws = XLSX.utils.json_to_sheet(data.checks);
                    const wb = XLSX.utils.book_new();
                    XLSX.utils.book_append_sheet(wb, ws, "Movements");
                    XLSX.writeFile(wb, `Chequeos.${parameters.period}.xlsx`);
                }

            } else {
                addNotificationStatus(data, setData);
            }
        } catch (error: any) {
            addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
        } finally { setLoading(false) }
    }

    useEffect(() => {
        const ids: OptionDefinition[] = data.checks.map((item: { idCheck: any; check: any; }) => ({
            value: item.idCheck,   // map idCheck → value
            label: item.check      // map check → label
        }));
        setListChecks(ids)

    }, [data]);
    return (
        <CustomAppLayout
            toolsHide
            contentType="form"
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                />
            }
            content={
                <>
                    <SpaceBetween direction="vertical" size="xs">

                        <Header actions={<Favorites />}>
                            Descarga de archivo de chequeos
                        </Header>
                        <Container>
                            <Form>
                                <SpaceBetween direction="vertical" size="xs">
                                    <SpaceBetween direction="horizontal" size="xs">
                                        <FormField label="Periodo" info={
                                            <Link onClick={() => {

                                                const updatedParameters = {
                                                    ...parameters, // clone existing keys
                                                    month: 3,
                                                    year: 2026,
                                                };
                                                setParameters(updatedParameters);
                                            }}>Limpiar</Link>
                                        }>
                                            <div style={{ width: 130 }}>
                                                <MPModal
                                                    width={120}
                                                    today prevMonth nextMonth
                                                    end={new Date()}
                                                    date={`${parameters.period}`}
                                                    onConfirm={(date) => {
                                                        setParameters({ ...parameters, period: date.period, month: date.month, year: date.year });
                                                    }}
                                                />
                                            </div>
                                        </FormField>
                                        <FormField label="&nbsp;">
                                            <Button onClick={handleRefreshMovements} style={{ root: btnIconForm }} disabled={parameters.year === "" || parameters.month === ""}><Icon path={mdiFileExcel} size={1} /></Button>
                                        </FormField>

                                    </SpaceBetween>
                                    <div style={{ width: 400 }}>
                                        <FormField label="Estado">
                                            <Multiselect
                                                selectedOptions={selectedStatues}
                                                onChange={({ detail }) =>
                                                    setSelectedStatues([...detail.selectedOptions])
                                                }
                                                options={[
                                                    { label: "Aprobado", value: "3", },
                                                    { label: "Rechazado", value: "2" },
                                                    { label: "Anulado", value: "-1" },
                                                    { label: "Asignado", value: "1" },
                                                    { label: "No Asignado", value: "0" }
                                                ]}
                                                placeholder="Seleccine uno o más estados"
                                            />
                                        </FormField>
                                    </div>
                                    <FormField label="Tipo de chequeo">
                                        <SelectCheck single={false} width={400}
                                            value={selectedChecks}
                                            onSelect={(options) => {
                                                if (options)
                                                    setSelectedChecks(options);
                                            }}
                                        />
                                    </FormField>
                                </SpaceBetween>
                            </Form>
                        </Container>
                    </SpaceBetween>
                </>
            }
        />
    );
};
